import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";

export const fetchPancardReport = createAsyncThunk(
  "pancardReport/fetchPancardReport",
  async ({ fromdate, todate }, { rejectWithValue }) => {
    if (!fromdate || !todate) {
      return rejectWithValue("Both 'fromdate' and 'todate' must be provided.");
    }
    try {
      const response = await axiosInstance.get("/api/panCard/getpandetails", {
        params: { fromdate, todate},
      });
      return response.data;
    } catch (error) {
      console.error("API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchAllPancardReport = createAsyncThunk(
  "pancardReport/fetchAllPancardReport",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/api/panCard/getall");
      return response.data;
    } catch (error) {
      console.error("API error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const pancardReportSlice = createSlice({
    name: "pancardReport",
    initialState: {
        pancardReport: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPancardReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPancardReport.fulfilled, (state, action) => {
                state.pancardReport = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchPancardReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(fetchAllPancardReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllPancardReport.fulfilled, (state, action) => {
                state.pancardReport = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchAllPancardReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});


export default pancardReportSlice.reducer;
